import Controller_ABI from "./ABI_Controller.json";
import Account_ABI from "./ABI_Account.json";
import PooledFund_ABI from "./ABI_PooledFund.json";
import DepositWithdraw_ABI from "./ABI_DepositWithdraw.json";
import Frontend_ABI from "./ABI_Frontend.json";
import TokenHolder_ABI from "./ABI_TokenHolder.json";
import ERC20_ABI from "./ABI_IERC20TE.json";
import { ethers } from "ethers";
import { BigNumber } from "../global/utils";
import { Modify } from "../global/helpers";

const _defaultContract = {
  name: "",
  abi: new Array<any>(),
  address: "",
  functions: undefined
};
export type IContract = Modify<typeof _defaultContract, { functions?: ethers.Contract; }>;
const defaultContract: IContract = _defaultContract;

const _defaultContract_NoAddress = {
  ...defaultContract,
  address: undefined
};
export type IContract_NoAddress = Modify<typeof _defaultContract_NoAddress, { address?: string; }>;
// const defaultContract_NoAddress: IContract_NoAddress = _defaultContract_NoAddress;

const _defaultTokenContract = {
  ...defaultContract,
  coinbaseName: undefined,
  decimals: BigNumber(0),
  denominator: BigNumber(0)
};
export type ITokenContract = Modify<typeof _defaultTokenContract, { coinbaseName?: string; }>;
const defaultTokenContract: ITokenContract = _defaultTokenContract;

// Addresses updated 2 June 2024
const contracts = {
  Controller: {
    name: "Controller",
    abi: Controller_ABI,
    address: "0x7E7E742AB1965e4d96940071f4248018287875A5", // permanent // OLD: "0x7E7EE0FFd004b16DC3a5F9A1d9862575D0b033Ae", 
    functions: undefined
  } as IContract,
  Account: {
    name: "Account",
    abi: Account_ABI,
    address: undefined, // grab from Frontend --> SystemSummary()
    functions: undefined
  } as IContract_NoAddress,
  PooledFund: {
    name: "PooledFund",
    abi: PooledFund_ABI,
    address: undefined, // grab from Frontend --> SystemSummary()
    functions: undefined
  } as IContract_NoAddress,
  DepositWithdraw: {
    name: "DepositWithdraw",
    abi: DepositWithdraw_ABI,
    address: undefined, // grab from Frontend --> SystemSummary()
    functions: undefined
  } as IContract_NoAddress,
  Frontend: {
    name: "Frontend",
    abi: Frontend_ABI,
    address: undefined, // grab from Controller --> FRONTEND()
    functions: undefined
  } as IContract_NoAddress,
  TokenHolder: {
    name: "TokenHolder",
    abi: TokenHolder_ABI,
    address: "0x219CDb4d0d2e626b9DD485b81EdD1690E2CcE5d9", // OLD, broken wavax: "0x2D0c136451D0AF0Dc81fff9aE421CE7D7950db49", // permanent
    functions: undefined
  } as IContract,
  TE: {
    name: "TE",
    abi: ERC20_ABI,
    address: "0x77171464ae48a2C96B3b7E513e9EEc5843207E7E", // permanent
    functions: undefined,
    coinbaseName: undefined,
    decimals: BigNumber(6),
    denominator: BigNumber(10).pow(6)
  } as ITokenContract,
  USDC: {
    name: "USDC",
    abi: ERC20_ABI,
    address: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E", // permanent
    functions: undefined,
    coinbaseName: "USD",
    decimals: BigNumber(6),
    denominator: BigNumber(10).pow(6)
  } as ITokenContract,
  AVAX: {
    name: "AVAX",
    abi: ERC20_ABI,
    address: "0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", // permanent
    functions: undefined,
    coinbaseName: "AVAX",
    decimals: BigNumber(18),
    denominator: BigNumber(10).pow(18)
  } as ITokenContract,
  WAVAX: {
    name: "WAVAX",
    abi: ERC20_ABI,
    address: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7", // permanent
    functions: undefined,
    coinbaseName: "AVAX",
    decimals: BigNumber(18),
    denominator: BigNumber(10).pow(18)
  } as ITokenContract,
  BTCb: {
    name: "BTC.b",
    abi: ERC20_ABI,
    address: "0x152b9d0FdC40C096757F570A51E494bd4b943E50", // permanent
    functions: undefined,
    coinbaseName: "BTC",
    decimals: BigNumber(8),
    denominator: BigNumber(10).pow(8)
  } as ITokenContract,
  WBTCe: {
    name: "WBTC.e",
    abi: ERC20_ABI,
    address: "0x50b7545627a5162F82A992c33b87aDc75187B218", // permanent
    functions: undefined,
    coinbaseName: "BTC",
    decimals: BigNumber(8),
    denominator: BigNumber(10).pow(8)
  } as ITokenContract,
  WETHe: {
    name: "WETH.e",
    abi: ERC20_ABI,
    address: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB", // permanent
    functions: undefined,
    coinbaseName: "ETH",
    decimals: BigNumber(18),
    denominator: BigNumber(10).pow(18)
  } as ITokenContract
};

export class ContractManager {
  contracts = contracts;

  cash = defaultTokenContract;
  asset = defaultTokenContract;

  getContractByAddress(address: string): IContract | IContract_NoAddress | ITokenContract | undefined {
    for (const contract of Object.values(this.contracts)) {
      if (contract.address?.toUpperCase() === address.toUpperCase()) {
        return contract;
      }
    }
  }
}